export default __webpack_public_path__ + "static/media/tickBox2.4952e284.svg";